<template>
    <div class="menu_top_lite">
        <Toast />
        <div class="menu_top_lite__logo">
            <a href="/ru/" title="На главную" class="logo"><img :src="getLogoLink" alt="На главную"></a>
        </div>
        <div v-if="isUserAuthenticated" class="logout">
            <a class="menu_top_lite__ico" href="/ru/logout">Выход</a>
        </div>
    </div>
</template>

<script>
import Toast from 'primevue/toast';

export default {
    name: "MenuTopLite",
    data() {
        return {
            login: false,
        }
    },
    computed: {
        isUserAuthenticated() {
            return this.$store.getters.IS_USER_AUTHENTICATED;
        },
        getLogoLink() {
            let date = new Date()
            if ((new Date('2025-11-11T00:00:00+03:00')) < date && date < (new Date('2025-11-14T00:00:00+03:00'))) {
                return '/i/icons/keys11_logo.svg'
            }
            return '/i/icons/logo-light.svg';
        },
    },
    components: {
        Toast,
    }
}
</script>
<style scoped>
.menu_top_lite {
    display: inline-flex;
    width: 100%;
    justify-content: space-between;
    padding: 8px 10px;
    min-height: 60px;
    background-color: #33404d;
    position: sticky;
    top: 0;
    z-index: var(--keysso-zindex-top-menu);
}
.menu_top_lite__ico {
    color: white;
    text-decoration: none;
    margin-right: 10px;
}
.menu_top_lite__ico:before {
    display: inline-block;
    width: 21px;
    height: 21px;
    background: url(/i/icons/logout.svg) no-repeat;
    content: "";
    vertical-align: middle;
    margin-right: 10px;
    background-size: cover;
}
</style>
